<template>
  <div class="view-marketing">
    <BannerCarousel section-type="marketing" scroll-target-id="cards" />
    <CardsGrid :page-id="pageId" variant="marketing" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CardsGrid from '@/components/common/cards-grid.vue';
import { PageEnum } from '@/models/page.enum';
import BannerCarousel from '@/components/common/banner-carousel.vue';

export default defineComponent({
  components: {
    BannerCarousel,
    CardsGrid,
  },
  data() {
    return {
      pageId: PageEnum.marketing,
    };
  },
});
</script>
